module.exports = __webpack_public_path__ + "img/2026big13.640dad14.png";